import { render, staticRenderFns } from "./VrainersSettings.vue?vue&type=template&id=1f7dcf75&scoped=true&"
import script from "./VrainersSettings.vue?vue&type=script&lang=js&"
export * from "./VrainersSettings.vue?vue&type=script&lang=js&"
import style0 from "./VrainersSettings.vue?vue&type=style&index=0&id=1f7dcf75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7dcf75",
  null
  
)

export default component.exports